module.exports = __webpack_public_path__ + "static/payor-cc-banner-mobile-4c1d51793934eabf731c453125bde5a4.jpg";